import { createAction } from 'redux-actions';
import {
  ADD_CUSTOM_FONT_COLOR,
  ADD_CUSTOM_SECTION_BORDER_COLOR,
  ADD_CUSTOM_SECTION_FILL_COLOR,
  ADD_CUSTOM_SYMBOL_STROKE_COLOR,
  ADD_CUSTOM_SYMBOL_FILL_COLOR
} from '@/constants';

export const addCustomFontColor = color =>
  createAction(ADD_CUSTOM_FONT_COLOR, () => color)();
export const addCustomSectionBorderColor = color =>
  createAction(ADD_CUSTOM_SECTION_BORDER_COLOR, () => color)();
export const addCustomSectionFillColor = color =>
  createAction(ADD_CUSTOM_SECTION_FILL_COLOR, () => color)();
export const addCustomSymbolStrokeColor = color =>
  createAction(ADD_CUSTOM_SYMBOL_STROKE_COLOR, () => color)();
export const addCustomSymbolFillColor = color =>
  createAction(ADD_CUSTOM_SYMBOL_FILL_COLOR, () => color)();
